/*
 * Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
 * #  This file forms part of the Trade-DSM application frontend.
 * #  https://github.com/Tooblippe/trade-dsm-frontend
 */

/**
 * Helper function to extract referrer from reload_url
 * @param {string} reloadUrl - The URL stored in localStorage (e.g., '/login?referrer=aexi')
 * @returns {string|null} - The referrer value or null if not found
 */
export function getLoginReferrerFromReloadUrl(reloadUrl) {
  if (!reloadUrl) return null;

  try {
    // Handle both legacy route names and new query-based URLs
    // Legacy: 'login_aexi', 'login_aexi_1', 'login_aexi_2'
    // New: '/login?referrer=aexi', '/login?referrer=aexi-1', etc.

    // Check for legacy route names first
    if (reloadUrl === 'login_aexi') return 'aexi';
    if (reloadUrl === 'login_aexi_1') return 'aexi-1';
    if (reloadUrl === 'login_aexi_2') return 'aexi-2';
    if (reloadUrl === 'login') return 'trade-advisory';

    // Parse query parameter from URL
    const url = new URL(reloadUrl, window.location.origin);
    const referrer = url.searchParams.get('referrer');
    
    return referrer || 'trade-advisory';
  } catch (error) {
    console.error('Error parsing reload URL:', error);
    return 'trade-advisory';
  }
}

/**
 * Helper function to generate canonical reload URL from referrer
 * @param {string} referrer - The referrer value (e.g., 'aexi-1', 'trade-advisory')
 * @returns {string} - The canonical URL format: '/login?referrer=...'
 */
export function toCanonicalReloadUrl(referrer) {
  if (!referrer) {
    referrer = 'trade-advisory';
  }
  
  // Normalize referrer to lowercase and sanitize
  let normalizedReferrer = referrer.toLowerCase();
  
  // Convert underscores to hyphens for URL consistency
  normalizedReferrer = normalizedReferrer.replace(/_/g, '-');
  
  // Remove any characters that aren't alphanumeric or hyphens
  normalizedReferrer = normalizedReferrer.replace(/[^a-z0-9-]/g, '');
  
  // Build canonical login URL with query param
  return `/login?referrer=${normalizedReferrer}`;
}

/**
 * Helper function to check if reload_url is an AEXI family route
 * @param {string} reloadUrl - The URL stored in localStorage
 * @returns {boolean} - True if it's an AEXI variant
 */
export function isAexiFamily(reloadUrl) {
  const referrer = getLoginReferrerFromReloadUrl(reloadUrl);
  if (!referrer) return false;
  
  return referrer.startsWith('aexi');
}
